module.exports = __webpack_public_path__ + "static/media/49.c2b6b8d4.png";